const home = {
  heroAlt: "Professionisti che esaminano progetti in una ristrutturazione",
  galleryAlt: "Settore edilizia e ristrutturazioni",
  install: {
    iosSub: "Scarica su",
    androidSub: "Disponibile su",
    iosTitle: "Installa su iPhone/iPad",
    iosDesc: "Apri questa pagina in Safari, tocca Condividi e poi 'Aggiungi alla schermata Home'.",
    androidTitle: "Installa l'app",
    androidDesc: "Apri il menu del browser e scegli 'Installa app' / 'Aggiungi a schermata Home'.",
  },
  apps: {
    nuvliTitle: "App mobile NuvliPro",
    nuvliDesc: "Preventivi, fatture, cantieri, spese e controllo dell'orario di lavoro sul tuo cellulare.",
    nuvliInstall: "Scarica NuvliPro",
    nuvliNote: "Installazione diretta (PWA) · funziona su Android e iPhone, senza occupare spazio.",
    workerTitle: "App mobile Timbratura GPS",
    workerDesc: "Per i dipendenti: timbratura di entrata/uscita con GPS e accesso con codice.",
    workerInstall: "Scarica Timbratura GPS",
    workerNote: "Per i lavoratori · dopo l'installazione, apri l'app e accedi con il tuo codice di accesso.",
    workerCta: "Apri l'app del lavoratore",
    qrTitle: "Controllo orario con GPS",
    qrSubtitle: "Timbratura facile e sicura per il tuo team",
    qrText: "Scaricala gratis dal nostro sito",
    qrInstall: "Installa sul cellulare",
    qrAvailable: "Disponibile per Android e iPhone",
  },
  login: {
    title: "Accedi", email: "Email", password: "Password", emailPh: "tu@email.com", submit: "Entra",
    forgot: "Hai dimenticato la password?", register: "Registrati gratis", welcome: "Benvenuto", error: "Errore di accesso",
  },
  features: {
    badge: "Funzionalità",
    title: "Tutto ciò che ti serve per gestire la tua attività",
    items: [
      { t: "Fatturazione", d: "Fatture con numerazione automatica, IVA e ritenute, stati e download in PDF professionale." },
      { t: "Preventivi", d: "Preventivi per capitoli e voci descrittive; trasformali in fattura con un clic." },
      { t: "Controllo spese", d: "Registra materiali, manodopera e forniture; controlla la spesa per cantiere e categoria." },
      { t: "Incassi parziali", d: "Registra acconti, controlla il saldo da incassare e invia ricevute automaticamente." },
      { t: "Report trimestrali", d: "IVA e imposte sul reddito per trimestre, pronte per il tuo commercialista ed esportabili in PDF ed Excel." },
      { t: "Gestione clienti", d: "Scheda completa di ogni cliente, storico dei documenti e rilevamento dei ritardi di pagamento." },
    ],
  },
  pricing: {
    badge: "Piani e prezzi",
    title: "Scegli il piano più adatto alla tua attività",
    subtitle: "Inizia gratis e senza scadenza. Passa a un piano superiore quando ti serve: nessun vincolo, disdici quando vuoi.",
    freeCta: "Crea un account gratuito",
    labels: { gratuito: "Piano Gratuito", trimestral: "Piano Trimestrale", anual: "Piano Annuale" },
    perMonth: "{{amount}}/mese",
    approx: "≈ {{amount}}/mese",
    periodo: { gratuito: "Senza scadenza", trimestral: "{{total}} ogni 3 mesi", anual: "{{total}} all'anno" },
    nota: { gratuito: "Per iniziare senza pagare", trimestral: "Senza limiti, con pagamento ogni 3 mesi", anual: "Un solo pagamento all'anno" },
    badges: { trimestral: "Il più scelto" },
    save: "Risparmi {{amount}}/anno",
    features: {
      gratuito: ["Fino a 8 clienti", "Fino a 8 preventivi", "Fatturazione e incassi parziali per i tuoi 8 clienti", "Spese e trimestrale: gli ultimi 2 trimestri", "2 progetti di cantiere", "Controllo presenze con lavoratori illimitati"],
      trimestral: ["Clienti, preventivi e cantieri illimitati", "Storico completo di spese e trimestri", "IA, VeriFactu e riconciliazione bancaria", "Promemoria via email e WhatsApp", "Esportazione per il tuo commercialista"],
      anual: ["Tutto il piano Trimestrale", "Documenti e logo personalizzati", "Avvisi automatici programmati", "Assistenza prioritaria"],
    },
    payCard: "Paga con carta",
    payNote: "Carta: rinnovo automatico, disdici quando vuoi",
    footnote: "Prezzi IVA esclusa · Pagamento con carta · Pagamento sicuro gestito da Stripe",
    approxNote: "Equivalente approssimativo in {{currency}} al cambio del giorno. L'importo esatto è indicato nella pagina di pagamento.",
    payError: "Impossibile avviare il pagamento",
  },
  trust: {
    title: "Professionisti che si fidano già di NuvliPro",
    subtitle: "Opinioni reali di aziende del settore edilizia e ristrutturazioni.",
    testimonials: [
      { cargo: "Direttore Generale", empresa: "Constructora MendozaBuild S.A.", texto: "Per oltre dieci anni abbiamo usato Excel e sistemi che non comunicavano tra loro. Con NuvliPro abbiamo riunito tutte le informazioni dei nostri 8 progetti e ridotto del 60% il tempo dedicato all'amministrazione. I report di redditività per progetto ora sono precisi e decido con dati reali, non con intuizioni." },
      { cargo: "Direttrice di Progetto", empresa: "Grupo Constructor Rojas & Asociados", texto: "Siamo passati da 3 a 12 progetti attivi e il nostro sistema manuale è crollato. Con NuvliPro siamo cresciuti senza raddoppiare il personale amministrativo: tracciabilità completa di ogni materiale, controllo dei subappaltatori in tempo reale e il 75% in meno di documentazione finale. I nostri clienti ricevono report che generano fiducia." },
      { cargo: "Titolare Autonomo", empresa: "18 anni nel settore", texto: "I miei lavori erano sempre più complessi e meno redditizi, e i costi mi sfuggivano senza sapere dove. Con NuvliPro ho individuato le perdite finanziarie, consolidato i fornitori e ridotto i costi generali del 22% senza rinunciare alla qualità. Ora preparo preventivi più dettagliati in meno tempo e chiudo più progetti." },
    ],
    seals: [
      { t: "Conforme al GDPR", d: "Dati protetti" },
      { t: "Crittografia SSL", d: "Connessione sicura" },
      { t: "Pagamenti con Stripe", d: "Incassi protetti" },
      { t: "Assistenza in spagnolo", d: "Quando ne hai bisogno" },
    ],
  },
  demo: {
    badge: "Video demo",
    title: "Scopri NuvliPro in 2 minuti",
    subtitle: "Guarda come creare un preventivo, trasformarlo in fattura e tenere sotto controllo incassi e spese.",
    unsupported: "Il tuo browser non supporta la riproduzione video.",
    soon: "Video demo in arrivo",
  },
  faq: {
    badge: "Domande frequenti",
    title: "Rispondiamo ai tuoi dubbi",
    items: [
      { q: "Servono conoscenze di contabilità per usare NuvliPro?", a: "No. NuvliPro è pensato per lavoratori autonomi e piccole imprese: crei preventivi e fatture compilando campi chiari e l'app calcola automaticamente IVA, ritenute e totali." },
      { q: "Posso provarlo gratis?", a: "Sì. Il Piano Gratuito non scade e non richiede carta: fino a 8 clienti, 8 preventivi, 8 fatture e 1 progetto di cantiere attivo. Quando ti serve di più, passa a un piano a pagamento." },
      { q: "I dati dei miei clienti sono al sicuro?", a: "Sì. Crittografiamo la connessione (SSL), rispettiamo il GDPR e i pagamenti sono gestiti in modo sicuro con Stripe. Non condividiamo mai i tuoi dati." },
      { q: "Posso personalizzare fatture e preventivi con il mio logo?", a: "Sì. Dalla tua Area personale puoi caricare il logo della tua azienda e scegliere il design del documento in linea con il tuo marchio." },
      { q: "NuvliPro serve per il controllo trimestrale delle imposte?", a: "Sì. Genera automaticamente il riepilogo dell'IVA a debito/a credito e delle imposte sul reddito per trimestre, esportabile in PDF ed Excel per il tuo commercialista." },
      { q: "Posso disdire quando voglio?", a: "Certo. Non ci sono vincoli: puoi cambiare o disdire il tuo piano in qualsiasi momento dal tuo account." },
    ],
  },
  contact: {
    badge: "Contatti",
    title: "Parliamone?",
    subtitle: "Raccontaci di cosa hai bisogno e ti risponderemo il prima possibile. Siamo qui per aiutarti a ottenere il massimo da NuvliPro.",
    support: "Assistenza clienti",
    supportNote: "Assistenza in spagnolo · risposta entro 24-48 h",
    name: "Nome", namePh: "Il tuo nome", email: "Email", emailPh: "tu@email.com",
    message: "Messaggio", messagePh: "Come possiamo aiutarti?", send: "Invia messaggio",
    sent: "Messaggio inviato! Ti risponderemo presto.", error: "Impossibile inviare il messaggio",
  },
  cta: {
    title: "Tutta la tua attività in un unico posto",
    items: ["Clienti", "Preventivi", "Fatturazione", "Incassi parziali", "Spese", "Trimestrale", "Ritardi di pagamento", "WhatsApp"],
    button: "Crea il mio account gratis",
  },
  footer: "Gestione completa per professionisti dell'edilizia e delle ristrutturazioni",
};
export default home;
